export const ARROW_UP_KEY = 'ArrowUp';
export const ARROW_DOWN_KEY = 'ArrowDown';
export const ENTER_KEY = 'Enter';
export const SPACE_KEY = 'Space';
export const TAB_KEY = 'Tab';
